import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icon-order-location.png'


const _withScopeId = n => (_pushScopeId("data-v-1006c3cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order" }
const _hoisted_2 = { class: "order-detail" }
const _hoisted_3 = { class: "order-detail-status" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "order-detail-user" }
const _hoisted_6 = { class: "order-detail-user-info" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "iphone" }
const _hoisted_9 = { class: "order-detail-module" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "商品信息", -1))
const _hoisted_11 = { class: "order-detail-product" }
const _hoisted_12 = { class: "product-img" }
const _hoisted_13 = { class: "product-info" }
const _hoisted_14 = { class: "item-info" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商品金额", -1))
const _hoisted_16 = { class: "score" }
const _hoisted_17 = {
  key: 0,
  class: "item-info"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "运费", -1))
const _hoisted_19 = { class: "score" }
const _hoisted_20 = { class: "order-cost" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单金额", -1))
const _hoisted_22 = {
  key: 0,
  class: "order-detail-module"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "快递单号", -1))
const _hoisted_24 = { class: "item-info" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "可自行复制去第三方平台查询", -1))
const _hoisted_26 = { style: {"width":"40%","text-align":"left"} }
const _hoisted_27 = ["data-clipboard-text"]
const _hoisted_28 = { class: "order-detail-other" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "订单信息", -1))
const _hoisted_30 = { class: "item-info" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单编号", -1))
const _hoisted_32 = ["data-clipboard-text"]
const _hoisted_33 = { class: "item-info" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下单时间", -1))

import { ref, onActivated } from 'vue';
import Navigate from "@/components/Navigate";
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Clipboard from 'clipboard';
import { showToast } from 'vant';

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDetail',
  setup(__props) {

const $router = useRouter();
const store = useStore() // 该方法用于返回store 实例
const showStatus = ref({
    'TO_BE_SHIPPED': {
        title: '待发货',
        name: '商品正在准备中',
        url: require('../assets/icon-order-send.png')
    },
    'SHIPPED': {
        title: '待收货',
        name: '商品已发货',
        url: require('../assets/icon-order-send.png')
    },
    'FINISHED': {
        title: '已完成',
        name: '您的订单已签收',
        url: require('../assets/icon-order-success.png')
    },
    'CANCEL':  {
        title: '已取消',
        name: '积分将退回到原账户',
        url: require('../assets/icon-order-cancel.png')
    }
})

const orderDetails = ref({
    orderStatus: 'SHIPPED',
})
const hrefLink = ref('');
const isFormExchange = ref('')

onActivated(() => {
    hrefLink.value = window.localStorage.getItem('hrefLink') as string;
    isFormExchange.value = $router.currentRoute.value.query?.isFormExchange as string;
    console.log('store.state.orderDetails', store.state.orderDetails)
    orderDetails.value = store.state.orderDetails;
})

const copy = () => {
    const clipboard = new Clipboard('.tag-read')
    clipboard.on('success', e => {
        console.log('复制成功')
        showToast('复制成功');
        // 释放内存
        clipboard.destroy()
    })
    clipboard.on('error', e => {
        // 不支持复制
        console.log('该浏览器不支持复制')
        // 释放内存
        clipboard.destroy()
    })
}

const copyNo = () => {
    const clipboard = new Clipboard('.express-no-read')
    clipboard.on('success', e => {
        console.log('复制成功')
        showToast('复制成功');
        // 释放内存
        clipboard.destroy()
    })
    clipboard.on('error', e => {
        // 不支持复制
        console.log('该浏览器不支持复制')
        // 释放内存
        clipboard.destroy()
    })
}

// const poster = () => {
//     window.location.href = `https://m.kuaidi100.com/app/query/?nu=${orderDetails.value.expressNo}&coname=${window.localStorage.getItem('currentState')}`
// }

const goBack = () => {
    if(isFormExchange.value) {
        $router.go(-5)
    }else {
        $router.go(-2)
    }
    
}

return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _createElementVNode("img", {
            src: showStatus.value[orderDetails.value.orderStatus].url,
            alt: ""
          }, null, 8, _hoisted_4),
          _createElementVNode("span", null, _toDisplayString(showStatus.value[orderDetails.value.orderStatus].title), 1)
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("span", null, _toDisplayString(showStatus.value[orderDetails.value.orderStatus].name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, [
            _hoisted_7,
            _createElementVNode("span", null, "收货人：" + _toDisplayString(orderDetails.value.receiver), 1)
          ]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(orderDetails.value.receiverMobile), 1)
        ]),
        _createElementVNode("p", null, _toDisplayString(orderDetails.value?.address?.replace(new RegExp(',','g'), ' ')), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_van_image, {
              src: orderDetails.value.productImage
            }, {
              loading: _withCtx(() => [
                _createVNode(_component_van_loading, {
                  type: "spinner",
                  size: "20"
                })
              ]),
              _: 1
            }, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", null, _toDisplayString(orderDetails.value.productName), 1),
            _createElementVNode("p", null, _toDisplayString(orderDetails.value.subTitle), 1),
            _createElementVNode("p", null, [
              _createElementVNode("span", null, "x" + _toDisplayString(orderDetails.value.quantity), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", null, [
            _createElementVNode("em", _hoisted_16, _toDisplayString(orderDetails.value.points), 1),
            _createTextVNode("积分")
          ])
        ]),
        (orderDetails.value.expressPoints)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("span", null, [
                _createElementVNode("em", _hoisted_19, _toDisplayString(orderDetails.value.expressPoints), 1),
                _createTextVNode("积分")
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("span", null, [
            _createElementVNode("em", null, _toDisplayString(orderDetails.value.usePoints), 1),
            _createTextVNode("积分")
          ])
        ])
      ]),
      (orderDetails.value.expressNo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(orderDetails.value.expressNo), 1),
                _createElementVNode("em", {
                  class: "express-no-read",
                  "data-clipboard-text": orderDetails.value.expressNo,
                  onClick: copyNo
                }, "复制", 8, _hoisted_27)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(orderDetails.value.orderCode), 1),
            _createElementVNode("em", {
              class: "tag-read",
              "data-clipboard-text": orderDetails.value.orderCode,
              onClick: copy
            }, "复制", 8, _hoisted_32)
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("span", null, _toDisplayString(orderDetails.value.createTime), 1)
        ])
      ]),
      _createElementVNode("div", { class: "link-to-home" }, [
        _createElementVNode("button", {
          onClick: goBack,
          class: "gohome"
        }, "返回首页")
      ])
    ])
  ]))
}
}

})